export default __webpack_public_path__ + "static/media/Cover.2e061cfc.png";